/* eslint jsx-a11y/no-static-element-interactions: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Popover from 'rp-react-common/PopoverComponent';
import PopoverListItem from 'rp-react-common/PopoverListItem';
import Abbr from 'rp-react-common/Abbr';

const popoverListConfig = ['course', 'class', 'prize'];

class CustomHeaderCell extends Popover {
    constructor(props) {
        super(props);

        const { expanded, sortBy } = props;
        this.state = {
            expanded,
            sortBy,
        };

        this.cancelStopPropag = false;
    }

    handleClick = (e) => {
        const { sortBy } = this.props;
        this.setState({
            expanded: !this.state.expanded,
        });

        if (!this.cancelStopPropag) {
            e.stopPropagation();

            const isHeaderCellSorted = this.node
                .closest('.ui-table__cell_header')
                .classList
                .contains('ui-table__cell_sorted');

            if (sortBy !== '' && !isHeaderCellSorted) {
                this.setState({
                    sortBy: '',
                });
            }
        } else {
            this.cancelStopPropag = false;
        }
    }

    onSelect = (sortBy) => {
        this.setState({
            sortBy,
        });
        this.props.onUpdate(sortBy);
        this.cancelStopPropag = true;
    }

    render() {
        const { expanded, sortBy } = this.state;

        return (
            <div
                className="cm-popoverList__popoverWrapper"
                onClick={this.handleClick}
                ref={(el) => { this.node = el; }}
            >
                <Abbr
                    title="Course / Class / Type / Prize"
                    breakpoint="sm"
                >
                    conditions
                </Abbr>
                {
                    expanded &&
                        <div
                            className={classNames(
                                'cm-popoverList__popover',
                                'ui-popover',
                                'ui-popover_customised',
                            )}
                        >
                            {
                                popoverListConfig.map(listItem => (
                                    <PopoverListItem
                                        key={listItem}
                                        isSelected={sortBy === listItem}
                                        onSelect={() => this.onSelect(listItem)}
                                        text={listItem === 'prize' ? 'prize money' : listItem}
                                    />
                                ))
                            }
                        </div>
                }
            </div>
        );
    }
}

CustomHeaderCell.propTypes = {
    expanded: PropTypes.bool,
    sortBy: PropTypes.string,
};

export default CustomHeaderCell;



// WEBPACK FOOTER //
// ./src/js/horse/form/formTable/CustomHeaderCell.jsx